import styled, { css } from 'styled-components'
import PhoneInput from 'react-phone-input-2'

import {
  FormFieldOrientation,
  FormFieldOrientationValues,
} from '../../../types/form'
import FormLabel from '../../FormLabel'

export const Container = styled.div<{
  $isDisabled?: boolean
  $orientation?: FormFieldOrientationValues
}>`
  display: flex;
  flex-flow: column;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
    `}

  ${({ $orientation }) =>
    $orientation &&
    $orientation === FormFieldOrientation.Horizontal &&
    css`
      flex-direction: row;
      gap: 2rem;
      align-items: center;
    `};
`

export const Label = styled(FormLabel)`
  margin-bottom: 0.5rem;
`

export const Input = styled(PhoneInput)<{
  $isDisabled?: boolean
}>`
  width: 100%;

  & .flag-dropdown {
    display: none;
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: not-allowed;
    `};

  input {
    ${({ theme }) => theme.textStyles.firaSansTextBase};

    &::placeholder {
      color: grey;
    }
  }
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  color: grey;
  margin-top: 0.5rem;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  color: ${({ theme }) => theme.colors.error};
  margin-top: 0.5rem;
`
